import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'react-oidc-context'; // Import AuthProvider
import { WebStorageStateStore } from 'oidc-client-ts';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

// Configure your Cognito OIDC properties
const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY, // Your Cognito User Pool URL
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID, // Your Cognito App Client ID
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URL, // Your redirect URI
  response_type: "code", // Response type
  scope: "phone openid email aws.cognito.signin.user.admin", // Scopes you want to request
  
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    const redirectTo = localStorage.getItem('MEsightIATpostLoginRedirect') || '/';
    localStorage.removeItem('MEsightIATpostLoginRedirect');
    window.location.replace(redirectTo);
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}> {/* Wrap App with AuthProvider */}
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
